import { format, lastDayOfMonth } from 'date-fns'

export const EMPTY_WALLET_NOTICE = 'Nothing to withdraw yet. Agency income moves here as invoices are approved.'

/** e.g. `Nedbank••••7170`. Mirrors the "Linked account" shown in the To Do List drawer. */
export const formatLinkedAccount = (bankName = '', accountNumber = ''): string => {
  const lastFour = String(accountNumber).slice(-4)
  return lastFour ? `${bankName}••••${lastFour}` : bankName
}

/**
 * The commission wallet notice. A funded wallet is paid out automatically to the agency's
 * linked account on the last day of the current month at 22:00.
 */
export const getCommissionWalletNotice = ({
  balance,
  bankName,
  accountNumber,
  today = new Date(),
}: {
  balance: number
  bankName?: string
  accountNumber?: string
  today?: Date
}): string => {
  if (!balance || balance <= 0) {
    return EMPTY_WALLET_NOTICE
  }
  const account = formatLinkedAccount(bankName, accountNumber)
  const payoutDate = format(lastDayOfMonth(today), 'd MMM')
  return `Withdraws automatically${account ? ` to ${account}` : ''} on ${payoutDate} at 22:00.`
}
